import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailableOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/availableoption';
import { OptionPrice } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/optionprice';
import { OptionPrices } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/optionprices';
import { VehicleConfiguration } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleconfiguration';
import { VehicleOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoption';
import type { RootState } from '../store';

export const initialState: VehicleConfiguration = {
  valid: true,
  options: [],
  mandatoryOptions: [],
  colours: {
    hood: [],
    paint: [],
    trim: [],
  },
  stepOrder: [],
};

const updateAvailableOptionPrices = (
  options: AvailableOption[],
  updatedPrices: OptionPrice[]
) => {
  options.forEach((e) => {
    const updatedPrice = updatedPrices.find((f) => f.id === e.id);

    if (updatedPrice) {
      e.price = updatedPrice.price;
      e.monthlyRentalCost = updatedPrice.monthlyRentalCost;
    }
  });
};

const updateOptionPrices = (
  options: VehicleOption[],
  updatedPrices: OptionPrice[]
) => {
  options.forEach((e) =>
    e.items.forEach((i) => {
      const updatedPrice = updatedPrices.find((f) => f.id === i.id);

      if (updatedPrice) {
        i.price = updatedPrice.price;
        i.monthlyCost = updatedPrice.monthlyRentalCost;
      }
    })
  );
};

export const vehicleConfigurationSlice = createSlice({
  name: 'vehicleConfiguration',
  initialState: initialState,
  reducers: {
    updateVehicleConfiguration: (
      state,
      action: PayloadAction<VehicleConfiguration>
    ) => {
      if (action.payload) {
        state.valid = action.payload.valid;
        state.options = action.payload.options;
        state.mandatoryOptions = action.payload.mandatoryOptions;
        state.colours = action.payload.colours;
        state.stepOrder = action.payload.stepOrder;
      }
    },
    updateVehicleConfigurationPrices: (
      state,
      action: PayloadAction<OptionPrices>
    ) => {
      updateAvailableOptionPrices(
        state.colours?.hood,
        action.payload.colourOptionPrice.hood
      );
      updateAvailableOptionPrices(
        state.colours.paint,
        action.payload.colourOptionPrice.paint
      );
      updateAvailableOptionPrices(
        state.colours.trim,
        action.payload.colourOptionPrice.trim
      );
      updateOptionPrices(state.options, action.payload.optionPrices);
    },
  },
});

export const { updateVehicleConfiguration, updateVehicleConfigurationPrices } =
  vehicleConfigurationSlice.actions;

export const vehicleInformation = (state: RootState) =>
  state.vehicleConfiguration;

export default vehicleConfigurationSlice.reducer;
